module.exports = __webpack_public_path__ + "static/media/WA3F1025.6c453bec.svg";